// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"22a6c9c6d99644fdf046","678":"c95f31b99cf028aa79a9"}[chunkId] + ".js";
};